import React, { FC } from 'react'

import { Route, Routes } from 'react-router-dom'

import FormMotoristas from './Form'
import ListMotoristas from './List'

const Motoristas: FC = () => {
  return (
    <Routes>
      <Route path="/Consultar" element={<ListMotoristas />} />
      <Route path="/Incluir" element={<FormMotoristas mode="add" />} />
      <Route path="/Alterar/:id" element={<FormMotoristas mode="edit" />} />
    </Routes>
  )
}

export default Motoristas
